// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div[role*="tablist"] {
    margin-bottom: 0;
}

.table-button {
    padding: 0 15px;
}

.table-button span {
    font-size: 12;
}`, "",{"version":3,"sources":["webpack://./src/asset/style/settings/manageusers/manageusers.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB","sourcesContent":["div[role*=\"tablist\"] {\n    margin-bottom: 0;\n}\n\n.table-button {\n    padding: 0 15px;\n}\n\n.table-button span {\n    font-size: 12;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
